// Constants
export const CREATE_PRODUCT: string = "Create Product";
export const SORT: string = "Sort";
export const PRODUCT_TYPE: string = "Product type";
export const CATEGORY_LIST: string = "Category List";


// Path
export const PRODUCT_DELTA_CATEGORY_LIST: string = "/gms/products";
export const PRODUCT_DELTA_LIST: string = "/gms/products/list";
export const PRODUCT_DIAGNOSTICS: string = "/gms/products/diagnostics";
export const PRODUCT_CREATE: string = "/gms/product/edit/0";

// RBAC key gating the Diagnostics entry point (granted by BE to
// Compatio SuperAdmin / Guide Party Admin / Commend Party Admin — US 12396)
export const DIAGNOSTICS_PERMISSION: string = "gmsproducts_diagnostics";

// Environment platforms for which Diagnostics is hidden: their SKUs differ per environment,
// so cross-environment SKU comparison does not apply. BigCommerce since US 15428, Shopify
// since 2026-10-15. Exact casing as stored in env_config (the platform options in the BE
// admin config, Entities/env_admin_config.json).
export const DIAGNOSTICS_HIDDEN_PLATFORMS: readonly string[] = ["BigCommerce", "Shopify"];

// Bulk Action Menu Items
export const CREATE_UPDATE: string = "Create/Update";
export const PDW_CREATE: string = "Create";
export const PDW_UPDATE: string = "Update";
export const PDW_VALIDATE: string = "Validate";
export const RECATEGORIZE: string = "Recategorize";
export const MAX_RECATEGORIZE_PRODUCTS: number = 250;
export const RECATEGORIZE_LIMIT_TOOLTIP: string = "Recategorization supports up to 250 items at a time. Please reduce your selection.";
export const DOWNLOAD_ALL_AS_XLS: string = "Download all as XLS";
export const DOWNLOAD_TEMPLATE: string = "Download Template";
export const VIEW_LOGS: string = "View Logs";
export const BULK_DELETE: string = "Bulk Delete";
export const DELETE_SELECTED: string = "Delete Selected";
export const UPLOAD_XLS: string = "Upload XLS";


// Product Form
export const NAME_INFO = "Name must be 2-60 characters long, contain letters, numbers and spaces, and must not contain specialcharacters."

// for rule rerun on manage products
export const LOADING = "Loading";
export const SUCCESS = "Success";
export const ERROR = "Error";




// Product delete — "Also delete this product from all other environments".
// Shared by the bulk, single-product and Upload XLS delete dialogs so the copy cannot
// drift between them. "All environments" means every environment of every channel in
// this domain, within the current workspace; the backend (`all_environments`) never
// touches another workspace that shares the domain — that workspace keeps the product.
// Who sees the checkbox: SAMS grants this to Compatio Super Admin, Guide Party Admin and
// Commend Party Admin only. Without it the checkbox is hidden and every delete is a
// current-environment delete. The backend enforces the same key (GMSProducts:fulldelete).
export const FULL_DELETE_PERMISSION: string = "gmsproducts_fulldelete";
export const DELETE_ALL_ENVIRONMENTS_LABEL = "Also delete this product from all other environments.";
export const DELETE_ENVIRONMENT_WARNING = "Deleting this product removes it from the current environment. It may still exist in other environments unless you choose to delete it everywhere.";
export const DELETED_FROM_CURRENT_ENVIRONMENT = "Product deleted from the current environment.";
export const DELETED_FROM_ALL_ENVIRONMENTS = "Product deleted from all environments.";
